import { Carousel } from '@fiverr-private/orca';

export const SLIDES_TO_SHOW = 5;

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
export const SCROLL_TYPE = Carousel.SCROLL_TYPE.ROW;

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
export const BREAKPOINT_BP_600: number = Carousel.BREAKPOINTS.BP_600;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
export const BREAKPOINT_BP_750: number = Carousel.BREAKPOINTS.BP_750;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
export const BREAKPOINT_BP_900: number = Carousel.BREAKPOINTS.BP_900;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
export const BREAKPOINT_BP_1160: number = Carousel.BREAKPOINTS.BP_1160;

export const BREAKPOINTS = {
    [BREAKPOINT_BP_600]: 2,
    [BREAKPOINT_BP_750]: 3,
    [BREAKPOINT_BP_900]: 4,
    [BREAKPOINT_BP_1160]: 5,
};
